"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.882 5.646h1V3.597A2.55 2.55 0 0 1 7.429 1.05h1.254c1.404 0 2.547 1.142 2.547 2.607v.145h1v-.205A3.551 3.551 0 0 0 8.683.05H7.429a3.55 3.55 0 0 0-3.545 3.435l-.002 2.161Zm-.232 2.12a.858.858 0 0 0-.857.856v5.471c0 .472.384.857.857.857h8.7a.859.859 0 0 0 .857-.857v-5.47a.859.859 0 0 0-.857-.858h-8.7Zm8.7 8.184h-8.7a1.859 1.859 0 0 1-1.857-1.857v-5.47A1.86 1.86 0 0 1 3.65 6.765h8.7c1.024 0 1.857.833 1.857 1.857v5.471a1.859 1.859 0 0 1-1.857 1.857Zm-3.824-4.812a1.025 1.025 0 1 0-.92.01v2.31h.92v-2.32Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.846 9.081H6.97v-3.84a4.12 4.12 0 0 1 4.115-4.116h1.924a4.12 4.12 0 0 1 4.116 4.115v.315h1.125V5.24C18.25 2.35 15.9 0 13.01 0h-1.925a5.245 5.245 0 0 0-5.237 5.07l-.002 4.01Zm-.562 2.353c-.84 0-1.52.683-1.52 1.521v8.399c0 .839.68 1.52 1.52 1.52h13.357c.838 0 1.52-.681 1.52-1.52v-8.399c0-.838-.682-1.52-1.52-1.52H5.284ZM18.641 24H5.284a2.65 2.65 0 0 1-2.646-2.646v-8.399a2.65 2.65 0 0 1 2.646-2.646h13.357a2.65 2.65 0 0 1 2.646 2.646v8.399A2.65 2.65 0 0 1 18.64 24Zm-5.87-7.183a1.575 1.575 0 1 0-1.414.016v3.545h1.413v-3.561Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.794 12.108h1.5V6.987A5.493 5.493 0 0 1 14.781 1.5h2.566a5.494 5.494 0 0 1 5.488 5.487v.42h1.5v-.42C24.335 3.134 21.2 0 17.347 0h-2.566a6.994 6.994 0 0 0-6.983 6.759l-.004 5.349Zm-.748 3.138a2.03 2.03 0 0 0-2.028 2.028v11.198A2.03 2.03 0 0 0 7.046 30.5h17.809a2.03 2.03 0 0 0 2.028-2.028V17.274a2.03 2.03 0 0 0-2.028-2.028H7.045ZM24.855 32H7.045a3.532 3.532 0 0 1-3.527-3.528V17.274a3.532 3.532 0 0 1 3.528-3.528h17.809a3.532 3.532 0 0 1 3.528 3.528v11.198A3.532 3.532 0 0 1 24.855 32Zm-7.828-9.577a2.1 2.1 0 1 0-1.884.02v4.728h1.884v-4.748Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.499 18.162h1.875V10.48c0-4.642 3.777-8.419 8.418-8.419h3.849c4.642 0 8.42 3.777 8.42 8.419v.63h1.874v-.63c0-5.676-4.618-10.294-10.294-10.294h-3.849c-5.56 0-10.106 4.434-10.288 9.951l-.005 8.024Zm-1.31 4.519a3.234 3.234 0 0 0-3.23 3.23v16.796a3.234 3.234 0 0 0 3.23 3.23H36.9a3.232 3.232 0 0 0 3.23-3.23V25.911a3.234 3.234 0 0 0-3.23-3.23H10.19ZM36.9 47.812H10.19a5.111 5.111 0 0 1-5.106-5.105V25.911a5.111 5.111 0 0 1 5.106-5.105H36.9a5.11 5.11 0 0 1 5.106 5.105v16.796a5.11 5.11 0 0 1-5.105 5.105Zm-11.74-14.38a2.97 2.97 0 0 0-1.444-5.57 2.972 2.972 0 0 0-1.382 5.603v7.291h2.826v-7.325Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.332 24.216h2.5V13.975c0-6.19 5.036-11.225 11.225-11.225h5.13c6.19 0 11.227 5.036 11.227 11.225v.84h2.5v-.84C47.914 6.407 41.756.25 34.188.25h-5.131c-7.415 0-13.475 5.91-13.718 13.268l-.007 10.698Zm-1.747 6.025a4.312 4.312 0 0 0-4.307 4.307v22.395a4.312 4.312 0 0 0 4.307 4.307h35.617a4.312 4.312 0 0 0 4.307-4.307V34.548a4.312 4.312 0 0 0-4.307-4.307H13.585Zm35.617 33.51H13.585a6.815 6.815 0 0 1-6.807-6.808V34.548a6.815 6.815 0 0 1 6.807-6.807h35.617a6.815 6.815 0 0 1 6.807 6.807v22.395a6.815 6.815 0 0 1-6.807 6.807ZM33.548 44.574a3.962 3.962 0 1 0-3.768.045v9.722h3.768v-9.767Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconLockOpen = function IconLockOpen(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Lock Open' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "LockOpen"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconLockOpen.sizes = [16, 24, 32, 48, 64];
IconLockOpen.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconLockOpen;
exports.default = _default;